module.exports = __webpack_public_path__ + "img/img_doc_buzdoc@2x.31ab92c8.png";